import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import OrderDetails, {
  TicketData,
} from '../../../../core/models/order.details';
import { OrderTicketData } from '../../components/order-ticket/order-ticket.component';
// @ts-ignore
import * as html2pdf from 'html2pdf.js';
import getMobileOS from '../../../../core/functions/getMobileOS';
import MobileOs from '../../../../core/enums/mobile-os';

@Component({
  selector: 'app-order-tickets',
  templateUrl: './order-tickets.component.html',
  styleUrls: ['./order-tickets.component.css'],
})
export class OrderTicketsComponent {
  @ViewChild('printSection') printSection!: ElementRef;

  @Input() order: OrderDetails | null = null;

  @Input() page = 1;
  @Input() totalPages = 1;
  @Input() pageTickets: TicketData[] = [];

  @Output() loading = new EventEmitter();

  public printingDate: Date = new Date();
  isDownloading = false;

  constructor() {}

  async onClickDownload(forPrint = false) {
    try {
      if (forPrint) {
        this.isDownloading = true;
      }

      await new Promise((resolve) => setTimeout(resolve, 500));

      let tickets: HTMLElement[] = Array.from(
        this.printSection.nativeElement.children
      );

      const os = getMobileOS();

      const ticket = tickets[0];
      const card = forPrint ? ticket.children[0].getElementsByClassName('card')[0] : ticket;
      let worker = html2pdf()
        .set({
          filename:
            os == MobileOs.IOS ? 'Tickets' : 'Tickets - TIX-' + this.order!.id,
          image: {
            quality: 1,
            type: 'webp',
          },
          html2canvas: {
            allowTaint: true,
            useCORS: true,
            scale: 2,
          },
          jsPDF: forPrint ? {
            unit: 'px',
            format: [card.clientWidth, card.clientHeight + 5],
            orientation: 'portrait',
          } : {},
          pagebreak: { mode: ['avoid', 'css', 'legacy'] }, // prevent splitting
        })
        .from(card)
        .toContainer()
        .toCanvas()
        .toPdf();

      for (let i = 1; i < tickets.length; i++) {
        const t = tickets[i];
        const card = forPrint ? t.children[0].getElementsByClassName('card')[0] : t;

        worker = worker
          .get('pdf')
          .then((pdf: any) => {
            pdf.addPage();
          })
          .from(card)
          .toContainer()
          .toCanvas()
          .toPdf();
      }

      const pdf = await worker.get('pdf');

      pdf.save('Tickets - TIX-' + this.order!.id);
    } catch (e) {
      console.log(e);
    } finally {
      setTimeout(() => {
        this.isDownloading = false;
      }, 1000);
    }
  }

  prepareData(ticket: TicketData): OrderTicketData {
    let label = ticket.label;
    if (ticket.isSeat && ticket.ticketType.block_id) {
      if (ticket.ticketType.block_id) {
        label = label.replace(/\w+_/, ``);
      }
    }

    return {
      eventDate: this.order?.event?.startAt ?? new Date(),
      eventName: this.order?.event?.name ?? '',
      buyerName: this.order?.buyerName ?? '',
      buyerEmail: this.order?.buyerEmail ?? '',
      eventPlace: this.order?.event?.place ?? '',
      orderId: this.order?.id ?? 0,
      printingDate: this.printingDate,
      ticketId: ticket.id,
      qrSource: ticket.qrcode,
      ticketStatus: ticket.checkInDate === null ? 'Disponible' : 'Usado',
      ticketLabel: ticket.isSeat ? label : undefined,
      ticketType: {
        data: { attributes: ticket.ticketType, id: ticket.ticketType.id },
      },
    };
  }
}
